import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { Login } from './pages/Login';
import { UsersList } from './pages/UsersList';
import { UserDetail } from './pages/UserDetail';
import { Purchases } from './pages/Purchases';
import { AppConfigPage } from './pages/AppConfig';
import { Mockups } from './pages/Mockups';
import { Feedback } from './pages/Feedback';
import { Deployments } from './pages/Deployments';
import { Header } from './components/Header';

export function App() {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="center">
        <p className="muted">Cargando sesión…</p>
      </div>
    );
  }

  if (!user) return <Login />;
  if (!isAdmin) return <NotAdmin />;

  return (
    <div className="app">
      <Header />
      <div className="container">
        <Routes>
          <Route path="/" element={<Navigate to="/users" replace />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/:uid" element={<UserDetail />} />
          <Route path="/purchases" element={<Purchases />} />
          <Route path="/config" element={<AppConfigPage />} />
          <Route path="/mockups" element={<Mockups />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/deployments" element={<Deployments />} />
          <Route path="*" element={<Navigate to="/users" replace />} />
        </Routes>
      </div>
    </div>
  );
}

function NotAdmin() {
  const { user, logout } = useAuth();
  return (
    <div className="center">
      <div className="login-card">
        <h2>Acceso restringido</h2>
        <p>
          La cuenta <strong>{user?.email}</strong> no tiene permisos de administrador.
        </p>
        <button onClick={logout}>Cerrar sesión</button>
      </div>
    </div>
  );
}
